import React from "react";

const datatableOptions = {
  paginationOptions: {
    rowsPerPageText: "View",
  },
  customStyle: {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#005b9b",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        minHeight: "45px",
        textAlign: "center",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        // borderRight: "1px solid #fff",
        position: "relative",
        justifyContent: "center",
        "&::after": {
          position: "absolute",
          content: "",
          background: "#bbbbbb",
          bottom: "0",
          right: "0",
          height: "100%",
          width: "1.5px",
        },
      },
    },
    rows: {
      style: {
        "&:nth-child(odd)": {
          backgroundColor: "#e8e8e8",
        },
        fontWeight: "600",
        borderTop: "none",
        ":not(:last-of-type)": {
          borderBottomStyle: "none",
        },
      },
    },
    cells: {
      style: {
        "&:(:after)": {
          position: "absolute",
          content: '""',
          background: "#bbbbbb",
          bottom: "0",
          right: "0",
          height: "100%",
          width: "1.5px",
        },
        justifyContent: "center",
        fontWeight: "600",
        position: "relative",
      },
    },
  },
};
export default { datatableOptions };
